var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', _vm._b({}, 'div', {
    style: _vm.style
  }, false), [_vm._t("default")], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }